import { useMemo } from 'react';

import useLayoutConfigurations from '@hooks/Configurations/UseLayoutConfiguration';

const useFooterLines = () => {
    const layoutConfigurations = useLayoutConfigurations();

    //compose string array for footerLine{n} (1 to 2) from layoutConfigurations, add item only if value is not empty. Keep right order. Strip empty values.
    const footerLines = useMemo(() => {
        return ['footerLine1', 'footerLine2']
            .map((key) => layoutConfigurations[key] || '')
            .filter((line) => line.trim());
    }, [layoutConfigurations]);

    return footerLines;
};

export default useFooterLines;
